// @ts-nocheck
import SceneFeature from "../feature";

export default class SceneLayer extends SceneFeature {
	_id: number | string;

	/**
	 * Vytvoreni vrstvy.
	 *
	 * @param  {String|Number} [id] Volitelne ID
	 */
	constructor(scene, itemId, id) {
		super(scene, itemId);

		this._id = id || Math.random();
		this._active = false;
		this._copyright = {};
		this._before = false;
		this._interaction = true;
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "SceneLayer",
			type: "layer",
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		const rd = super.getCreateData();

		rd.id = this._id;
		rd.active = this._active;
		rd.copyright = this._copyright;
		rd.appended = this._appended;
		rd.before = this._before;

		return rd;
	}

	/**
	 * Povoleni vrstvy.
	 */
	enable(...args) {
		if (this._active) {
			return this;
		}

		this._onChange(this._scene.featureEvent("layerEnable", true, true), args);

		this._active = true;

		this._scene.makeEvent("layer-enable", null, this);

		return this;
	}

	/**
	 * Zakazani vrstvy.
	 */
	disable(...args) {
		if (!this._active) {
			return this;
		}

		this._onChange(this._scene.featureEvent("layerDisable", true, true), args);

		this._active = false;

		this._scene.makeEvent("layer-disable", null, this);

		return this;
	}

	/**
	 * Nastaveni copyrightu.
	 */
	setCopyright(...args) {
		this._copyright = args[0];

		this._onChange(this._scene.featureEvent("layerSetCopyright", true, true), args);
		this._scene.updateCopyrights();

		return this;
	}

	/**
	 * Vycisteni vrstvy.
	 */
	clear(...args) {
		this._onChange(this._scene.featureEvent("layerClear", true, true), args);
	}

	/**
	 * Smazani vsech entit vrstvy.
	 */
	removeAll(...args) {
		this._onChange(this._scene.featureEvent("layerRemoveAll", true, true), args);
	}

	/**
	 * Prekresleni vrstvy.
	 */
	redraw(...args) {
		this._onChange(this._scene.featureEvent("layerRedraw", true, true), args);
	}

	/**
	 * Ziskani ID vrstvy.
	 */
	getId() {
		return this._id;
	}

	/**
	 * Je vrstva aktivni?
	 *
	 * @return {Boolean}
	 */
	isActive() {
		return this._active;
	}

	/**
	 * Ziskani copyrightu.
	 *
	 * @return {Object}
	 */
	getCopyright() {
		return this._copyright;
	}

	/**
	 * Nastaveni pripnuti do sceny.
	 *
	 * @param {Boolean} before
	 */
	setBefore(before) {
		this._before = before;
	}

	/**
	 * Povolit interaktivitu nad vrstvou.
	 */
	enableInteraction() {
		this._interaction = true;
		this.getContainer(el => {
			el.classList.remove("layer-disable-interaction");
		}, this, true);
	}

	/**
	 * Zakazat interaktivitu nad vrstvou.
	 */
	disableInteraction() {
		this._interaction = false;
		this.getContainer(el => {
			el.classList.add("layer-disable-interaction");
		}, this, true);
	}
}
